module.exports = __webpack_public_path__ + "img/IndustrialData.d98ea8c3.png";